import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import DeleteTeam from '../../components/DeleteTeam/DeleteTeam';
import ManageLocks from '../ManageLocks/ManageLocks';

export const Settings: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <main className="jg-space-ptml">
      <Helmet title={t('title.settings')} />
      <h1 className="jg-h2 jg-space-mbml">{t('content.admintabs.settings')}</h1>
      <ManageLocks />
      <DeleteTeam />
    </main>
  );
};

export default Settings;
